<template>
  <div class="left">
    <div v-for="item in list" :key="item.name">
      <div style="border-top: 1px solid #e4eaed; margin-bottom: 14px"></div>
      <p class="fu">
        <svg
          t="1605852761368"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3297"
          width="32"
          height="32"
        >
          <path
            d="M512 624a112 112 0 1 0 0-224 112 112 0 0 0 0 224z"
            p-id="3298"
            fill="#8a8a8a"
          ></path>
        </svg>
        <span @click="clickFu(item)">{{ item.meta.title }}</span>
      </p>
      <router-link
        v-if="
          val.path &&
          val.path != 'securityScreen1' &&
          val.path != 'securityScreen2' &&
          val.path != 'securityScreen3'
        "
        class="child"
        v-for="(val, index) in item.children"
        :key="val.name"
        :to="`/index/` + val.path"
      >
        <el-badge
          v-if="val.meta.title == '安全事件' && totalNum > 0"
          :value="totalNum"
          class="item"
        >
          {{ val.meta.title }}
        </el-badge>
        <span v-else>{{ val.meta.title }}</span>
      </router-link>
      <div class="child" v-else @click="goOpen(val.path)">{{ val.meta.title }}</div>
      <!-- <div class="child" v-for="(val,index) in item.children" v-if="!val.path" :key="val.name">
				<div>{{val.name}}</div>
				<router-link style="padding-left: 20px;margin-top: 10px;" v-for="v in val.meta" :key="v.path" :to="v.path">{{v.title}}</router-link>
			</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
    iconUrl: {
      type: String,
    },
    totalNum: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    $route(val) {
      // let arr = val.path.split("/")
      // console.log("```````````````````````````");
      // console.log(arr);
    },
  },
  methods: {
    goOpen(path) {
      let pathInfo = this.$router.resolve({
        path: "/" + path,
        //  query:{
        //      productId:'11'
        //  }
      });
      window.open(pathInfo.href, "_blank");
      this.productId = this.$route.query.productId; //新页面的参数接收
    },
    clickFu(obj) {
      //点击父  默认去子的0索引path
      console.log(obj);
      if (obj.meta.title == "用户管理") {
        location.href = "http://192.168.0.192/system/user";
      }
      this.$router.push(obj.bdMenus[0].path);
    },
  },
};
</script>

<style scoped="scoped">
/deep/.el-badge__content.is-fixed {
  right: 3px !important;
}
.fu {
  display: flex;
  cursor: pointer;
  align-items: center;
  padding-bottom: 14px;
  font-size: 0.9rem;
}

.fu > span {
  color: #b0b0b0;
}

.child {
  padding-left: 32px;
  font-size: 0.9rem;
  padding-bottom: 14px;
  cursor: pointer;
}

.child:hover {
  color: #00a790;
  font-weight: bold;
}

.router-link-active {
  color: #00a790;
  font-weight: bold;
}
</style>
